module.exports = __webpack_public_path__ + "img/bot4.3b2b7b26.svg";